import { Component, inject, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { ajaxCall } from "../services/ajax-call.service";
import { faWifiSlash } from "@fortawesome/pro-regular-svg-icons";

@Component({
    template: ''
})
export class OfflineBaseComponent implements OnDestroy {

    farWifiSlash = faWifiSlash;

    private localAjax: ajaxCall;
    private offlineSubscription: Subscription;
    isOnline: boolean = true;

    constructor() {
        this.localAjax = inject(ajaxCall);

        this.offlineSubscription = this.localAjax.offlineWatch().subscribe({
            next: (status) => {
                this.isOnline = status;
            }
        });
    }

    ngOnDestroy(): void {
        this.offlineSubscription.unsubscribe();
    }
}